// Phase B5: admin-editable customiser copy.
//
// Each Template can override a fixed set of customer-facing strings
// (section titles, step labels, the text placeholder) via
// Template.copyOverrides. Every overridable label in the customiser is
// read through flowCopy(), which returns the merchant's override when
// present and non-blank, otherwise the hardcoded default.

import type { Config } from "./types";

export type CopyKey =
  | "reuseTitle"
  | "customiseTitle"
  | "addonsTitle"
  | "notesTitle"
  | "approvalTitle"
  | "placementLabel"
  | "modeLabel"
  | "textLabel"
  | "sizeLabel"
  | "uploadLabel"
  | "threadLabel"
  | "textPlaceholder";

export function flowCopy(config: Config, key: CopyKey, fallback: string): string {
  const v = config.product.copyOverrides?.[key];
  return typeof v === "string" && v.trim() ? v : fallback;
}
